__turbopack_context__.v({
  "fullPage": "LoadingOverlay-module__UpOq5a__fullPage",
  "loadingAnimation": "LoadingOverlay-module__UpOq5a__loadingAnimation",
  "loadingContainer": "LoadingOverlay-module__UpOq5a__loadingContainer",
  "overlay": "LoadingOverlay-module__UpOq5a__overlay",
});
